export default "__VITE_ASSET__BYdefr7F__"